import React, { useEffect, useState } from "react";
import logo from "../assets/images/logo.png";
import "./commanComponents.css";
import svgData from "../constants/utilities/svgData";
import { useNavigate } from "react-router-dom";
import { getUserDetails } from "../constants/helpers/getUserDetails";
// import { io } from "socket.io-client";
import { useQuery } from "react-query";
import toast from "react-hot-toast";
import { communication, getToken } from "../constants/apis/communication";
import PopupModel from "./PopupModel";
import { Modal } from "react-bootstrap";
import ColorBtn from "./buttons/ColorBtn";

export default function Navbar({ heading, showBackBtn = true }) {
  const navigate = useNavigate();
  const [show, setShow] = useState({ isOpen: false });

  const tokenName = process.env.REACT_APP_PUBLIC_TOKENNAME;
  const userDetails = process.env.REACT_APP_PUBLIC_USERDETAILS;
  // const [socket, setSocket] = useState("");
  const [notificationCount, setNotificationCount] = useState("");
  // const socket = io(process.env.REACT_APP_PUBLIC_NODE_URL, {
  //   transports: ["polling"],  // Try only polling first
  //   withCredentials: true,
  // });

  const { data, isFetching } = useQuery(["getNotificationCount"], () => communication?.getNotificationCount(), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status == "SUCCESS") {
        setNotificationCount(data?.data?.notification);
      } else if (data?.data?.status == "JWT_INVALID") {
        sessionStorage.removeItem(tokenName);
        sessionStorage.removeItem(userDetails);
        navigate("/login");
        setNotificationCount("");
      } else {
        setNotificationCount("");
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });
  // const { refetch, isFetching: syncMasterDataFetching } = useQuery(["syncMasterData"], () => communication?.syncMasterData(), {
  //   refetchOnWindowFocus: false,
  //   enabled: false,
  //   onSuccess: (data) => {
  //     if (data?.data?.status == "SUCCESS") {
  //       refetchlLastSyncDate();
  //       toast.success(`Success: ${data?.data?.message}`);
  //     }
  //   },
  //   onError: (error) => {
  //     toast.error(`Failed: ${error?.message}`);
  //   },
  // });

  // const {
  //   data: lastSyncDate,
  //   isFetching: isFetchingLastSyncDate,
  //   refetch: refetchlLastSyncDate,
  // } = useQuery(["getlastSyncDate"], () => communication?.getLastSyncDate(), {
  //   refetchOnWindowFocus: false,
  //   onError: (error) => {
  //     toast.error(`Failed: ${error?.message}`);
  //   },
  // });

  // useEffect(() => {
  //   const socketConnection = io("http://192.168.1.36:3033", {
  //     withCredentials: true, // Important for CORS with credentials
  //     transports: ["websocket", "polling"],
  //   });
  //   setSocket(socketConnection);
  //   return () => {
  //     socketConnection.disconnect();
  //   };
  // }, []);

  // useEffect(() => {
  //   if (socket) {
  //     socket.addEventListener("notificationCount", (event) => {
  //       console.log("Message from server ", event.data);
  //     });

  //     return () => {
  //       socket.off("notificationCount"); // Cleanup on unmount
  //     };
  //   }
  // }, [socket]);

  return (
    <div className="navbarWrapper">
      <div className="d-flex gap-3 align-items-center">
        <img src={logo} alt="logo" className="cursor-pointer" onClick={() => navigate("/panel/dashboard")} />
        <h4 className="fw-bold text-wrap">{heading}</h4>
      </div>
      {/* <div>
        {`Last data sync on ${formatDateTime(lastSyncDate?.data?.lastSyncDate)}`}{" "}
        {isFetchingLastSyncDate || syncMasterDataFetching ? (
          <div class="spinner-border spinner-border-sm" style={{ width: "20px", height: "20px", color: "#2a8a00" }} role="status"></div>
        ) : (
          <div onClick={() => refetch()} title="Click here to Sync Data">
            {svgData?.reloadIcon}
          </div>
        )}
      </div> */}
      <div className="d-flex gap-4 align-items-center">
        <div className="cursor-pointer" onClick={() => navigate("/panel/notification")}>
          <div>{svgData?.bellIcon}</div>
          {notificationCount && <h6>{notificationCount}</h6>}
        </div>
        <div className="d-flex gap-3 align-items-center">
          {/* <img src={defaultProfile} alt="profile" /> */}
          <div>
            <h6 className="fw-bold text-capitalize">{getUserDetails()?.name || "--"}</h6>
            <div className="text-capitalize">
              {Array.isArray(getUserDetails()?.designation)
                ? getUserDetails().designation.join(", ")
                : getUserDetails()?.designation || "--"}
            </div>
          </div>
        </div>
        <div
          title="Logout"
          onClick={() => {
            setShow({ isOpen: true });
          }}
        >
          {svgData?.logOutIcon}
        </div>
      </div>
      <PopupModel setShow={setShow} show={show?.isOpen} dialogClassName="logoutPopupDialog">
        <h3 className="logoutPopupTitle">Log Out ?</h3>
        <p className="logoutPopupText">Are you sure, You want to Logout ?</p>
        <div className="logoutPopupButtons">
          <button className="logoutPopupBtnCancel" onClick={() => setShow({ isOpen: false })}>
            Cancel
          </button>
          <button
            className="logoutPopupBtnConfirm"
            onClick={() => {
              sessionStorage.removeItem(tokenName);
              sessionStorage.removeItem(userDetails);
              navigate("/login");
            }}
          >
            Logout
          </button>
        </div>
      </PopupModel>
    </div>
  );
}
